import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { removeSpaceAfter } from '../../../../helpers/stringutils';
import { renderDurationText, renderDateText } from '../../../../helpers/cyoaHelper';
import _filter from 'lodash/filter';
import { FetchCapacity } from '../../../../actions/capacity';
import Spinner from '../../../shared/spinner';
import { UpdateTripInfo } from '../../../../actions/booking';
import { UpdateReservationsPayload } from '../../../../helpers/bookingHelper';
import { strCount } from '../../../../helpers/stringutils';
import CalenderPanel from './calendar-panel';
import ResponsiveImage from '../../../shared/responsiveImage';


class BuilderCard extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      editOpen:false,
      calenderOpen:false,
      calenderIndex:null,
      daySelected:"",
      departureDate:"",
      reservationIndex:"",
      numberOfDays:[],
      originalDepartures:[]
    }
    this.closeClicked = this.closeClicked.bind(this);
    this.plusClicked = this.plusClicked.bind(this);
    this.editClicked = this.editClicked.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onDayClick = this.onDayClick.bind(this);
  }

  datesToDays(capacityArray, selectedDate, plainsDates = false){

    // List of new dates after selected dates (don't show any dates before)
    let newDates = [];
    let _departures = capacityArray.map(item => item.departure_date);
    let _selectedDate = removeSpaceAfter(selectedDate);

    for(let i = 0; i < _departures.length; i++){
      if(new Date(_departures[i]) > new Date(_selectedDate)){
        newDates.push(_departures[i]);
      }
    }
    return plainsDates ? newDates :  newDates.map(item => { return (new Date(item) - new Date(_selectedDate)) / (1000*60*60*24)});
  }

  componentDidMount(){
    document.body.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }


  closeClicked(){
    this.props.onCloseClicked(this.props.sectors[this.props.index].tour_id, this.props.index);
  }

  plusClicked(){
    this.props.onPlusClicked();
  }

 editClicked(index, type){

    const {
      FetchCapacity,
      itineraries:{tms_group_booking_id, iso_currency, trips},
      sectors
    } = this.props;


    //Scroll into view
    ReactDOM.findDOMNode(this).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

    //Open edit day if sector
    if(type === 'sector' || type === 'post_fixed_trip'){

      //prevent last item edit click
      if(index === sectors.length - 1) return;

      // Save the departure date and fetch capacity dates for next destination
      this.setState({editOpen:!this.state.editOpen, departureDate:removeSpaceAfter(sectors[index].transfer.date_for), reservationIndex:index}, () => {

        if(this.state.editOpen){

          FetchCapacity(trips[0].tour_id, iso_currency, sectors[index+1].transfer.start_city_id, {}, "EDIT_DAYS_CAPACITY", tms_group_booking_id).then((data) => {

            this.setState({
              originalDepartures:this.datesToDays(data.data, sectors[index].transfer.date_for, true),
              numberOfDays:this.datesToDays(data.data, sectors[index].transfer.date_for, false)
            });

          });
        }
      });

    }

    //Open calendar if product
    if(type === 'product'){

      this.setState({calenderOpen:!this.state.calenderOpen, calenderIndex:index});

      // Fetch tour capacity
     FetchCapacity(sectors[index].tour_id, iso_currency, "", {}, "", tms_group_booking_id);

    }



  }

  onDayClick(daySelected){
    this.setState({daySelected:daySelected});
  }

  onConfirm(){

    const { UpdateTripInfo, itineraries, itineraries:{tms_group_booking_id} } = this.props;
    const { numberOfDays, daySelected, originalDepartures, reservationIndex } = this.state;

    const index = reservationIndex+1;
    const payload = UpdateReservationsPayload(itineraries, index, originalDepartures[numberOfDays.indexOf(daySelected)]);

    UpdateTripInfo(tms_group_booking_id, "update_sectors", payload).then(()=>{
      this.setState({
        editOpen:false,
        daySelected:"",
        departureDate:"",
        reservationIndex:"",
        numberOfDays:[],
        originalDepartures:[]
      });
    });

  }

  documentClickHandler(e){

    try{

       if(this.state.editOpen){
         if(e.target.offsetParent.className !== "builder-list-item builder-list-item-card " ){
           this.setState({editOpen:false});
         }
       }

     }catch(e){}

  }

  onCloseCalender(){
    this.setState({calenderOpen:false});
  }

  renderEditPanel(props, state){
    return (
      <div className={`edit-days-panel ${state.editOpen ? 'active' : ''}`}>
        <div className="loading-wrapper" style={{display:`${props.editDaysCapacity.isFetching ? 'block' : 'none'}`}}>
          <div className="row">
            <div className="column small-12">
              <Spinner text="Loading..." loadClass="orange-spinner-wrapper" />
            </div>
          </div>
        </div>
        <div className="days-wrapper" style={{display:`${props.editDaysCapacity.isFetching ? 'none' : 'block'}`}}>
          <div className="row">
            <div className="column small-12">
              <p className="update-text">Update number of days</p>
              <ul>
                {
                  state.numberOfDays.map((item, i) => {
                     return <li key={i} onClick={() => this.onDayClick(item)} className={`${state.daySelected === item ? 'active' : ''}`}>{item} days</li>
                  })
                }
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="column small-12">
              <button
                type="submit"
                className={`busabout--cta orange ${(state.daySelected !== "") ? '': 'disabled'}` }
                disabled={ (state.daySelected !== "") ? false : true}
                onClick={this.onConfirm}>
                  <span style={{display:props.isUpdating ? "none" : "block"}}>Confirm</span>
                  <span style={{display:props.isUpdating ? "block" : "none"}}><span className="fa fa-spinner fa-lg fa-spin"></span></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderEditCalenderPanel(state){
    return (
      <div className="edit-calendar-panel" style={{display: `${state.calenderOpen ? 'block' : 'none'}` }}>
        <CalenderPanel id={'edit-panel'} editIndex={state.calenderIndex} onCloseCalender={() => this.onCloseCalender()} />
      </div>
    )
  }

  render(){

    const { editOpen, calenderOpen } = this.state;

    const { id, type, showClose, showPlus, index, sequence, image, data, sectors, itineraries:{trips} } = this.props;


    let _image;

    if(id === 'edit-view'){
      _image = sequence.images;
    }

    if(id === 'next-destination-view'){
      _image = (type === 'sector') ? image.images : image.media;
    }



    let _description = (type === 'product') ? showClose ? _filter(trips, ['ctfl_id', sequence.product_ctfl_id])[0].builder_description : data.description : '';
    let _price = (type === 'product') ? showClose ? sequence.transfer.price : data.price : '';


    const productClass = (type === 'product') ? 'fixed-product' : '';
    const imageLink = _filter(_image, {'title': 'hero'})[0] !== undefined ? _filter(_image, {'title': 'hero'})[0].url : "";



    return (
      <div className="builder--card--wrapper" onClick={id === 'next-destination-view' ? this.plusClicked : null}>
        <div className={`builder--card ${id} ${productClass} ${(id === 'edit-view' && index+1 < sectors.length && sectors[index + 1].type === 'product') ? 'disable-edit-view' : ''}`} onClick={ id === 'edit-view' ?  () => this.editClicked(index, type) : null}>
          <div className="row">
            <div className="column small-12 medium-4 large-2">
              <div className="builder-card-image">
                <ResponsiveImage src={imageLink} width={114} widthRetina={228} alt={showClose ? sequence.name : data.name } quality={60} />
              </div>
            </div>
            <div className="column small-10 medium-6 large-7">
              <div className="builder-card-text">
                <h6 className={`busabout-h6 ${strCount(showClose ? sequence.name : data.name, 42, "small")}`}>{showClose ? sequence.name : data.name }</h6>
                <p className="subtitle" style={{display: (id === 'next-destination-view') ? "none" : "block"}}>
                 { showClose ? renderDateText(sectors, index, 'DD MMMM YYYY') : "" }
                </p>
                <p className="duration-text" style={{display: (id === 'next-destination-view') ? "none" : "block"}}>
                  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" className="clock-svg">
                    <path d="M7 0C3.133 0 0 3.133 0 7s3.133 7 7 7 7-3.133 7-7-3.133-7-7-7zm6.097 7A6.097 6.097 0 1 1 .903 7a6.097 6.097 0 1 1 12.194 0zM8.894 9.492L6.602 7.827a.34.34 0 0 1-.138-.274V3.048a.34.34 0 0 1 .338-.338h.396a.34.34 0 0 1 .338.338v4.13l1.99 1.448c.153.11.184.322.074.474l-.232.319a.341.341 0 0 1-.474.073z" fill="#F60" fillRule="nonzero"/>
                  </svg>
                  {
                  (type === 'product')
                  ?
                    <span>
                    <span className="viking-text uppercase text-left">{_description} <strong className="price orange-text">{this.props.currency}{_price}</strong></span>
                    </span>
                  : ''
                  }
                  { (id !== 'next-destination-view' && type !== "product") ? renderDurationText(sectors, index) : "" }
                  <svg style={{display: (id !== 'next-destination-view') ? "none" : "block"}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="chevron-down-svg">
                    <path d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"/>
                  </svg>
                </p>
                 {
                  (type === 'product' && id === 'next-destination-view')
                  ?
                    <span>
                    <span className="viking-text uppercase text-left">{_description} </span> <br />
                    <span className="price orange-text">price from <strong>{this.props.currency}{_price}</strong></span>
                    </span>
                  : ''
                  }
              </div>
            </div>

            <div className="columns small-2 button-svg" style={{display: (showClose && type !== "post_fixed_trip")  ? "block" : "none"}}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" className={`ellipse-svg ${editOpen ? 'active' : ''}`}>
                <path d="M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"/>
              </svg>
              <span className="edit-text">Edit</span>
              <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" onClick={this.closeClicked} className="close-svg">
                <path d="M10.978 9.56l7.673-7.713a.678.678 0 0 0 0-.956l-.475-.478a.67.67 0 0 0-.951 0L9.552 8.127 1.88.418a.67.67 0 0 0-.95 0L.453.896a.678.678 0 0 0 0 .956L8.126 9.56.46 17.274a.678.678 0 0 0 0 .956l.475.478a.67.67 0 0 0 .95 0l7.667-7.714 7.673 7.714a.67.67 0 0 0 .95 0l.476-.478a.678.678 0 0 0 0-.956L10.978 9.56z" fill="#F14859" fillRule="nonzero" opacity=".501"/>
              </svg>
            </div>

            <div className="columns small-2 button-svg" style={{display: showPlus ? "block" : "none"}}>
              <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" className="plus-svg">
                <g transform="translate(.22 .323)" fill="none" fillRule="evenodd">
                  <ellipse fill="#FFF" cx="12.445" cy="12.419" rx="12.445" ry="12.419"/>
                  <path d="M18.868 12.119v.6c0 .331-.27.602-.602.602h-4.918v4.907c0 .33-.27.601-.602.601h-.602a.603.603 0 0 1-.602-.6V13.32H6.624a.603.603 0 0 1-.602-.601v-.601c0-.33.27-.601.602-.601h4.918V6.61c0-.33.27-.6.602-.6h.602c.331 0 .602.27.602.6v4.908h4.918c.331 0 .602.27.602.6zm6.022.3c0 6.861-5.57 12.42-12.445 12.42S0 19.28 0 12.419C0 5.56 5.57 0 12.445 0S24.89 5.559 24.89 12.42zm-1.606 0c0-6.004-4.883-10.817-10.84-10.817-6.016 0-10.838 4.873-10.838 10.817 0 6.005 4.882 10.817 10.839 10.817 6.017 0 10.839-4.872 10.839-10.817z" fill="#F60" fillRule="nonzero"/>
                </g>
              </svg>
            </div>

          </div>
        </div>
        <div className="builder--card-option">
          {editOpen && this.renderEditPanel(this.props, this.state)}
          {calenderOpen && this.renderEditCalenderPanel(this.state)}
        </div>


      </div>
    )
  }
}



function mapStateToProps(state){
  return {
    editDaysCapacity:state.editDaysCapacity,
    isUpdating:state.bookingGroup.updating,
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchCapacity,
    UpdateTripInfo
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BuilderCard);



// WEBPACK FOOTER //
// ./src/components/itinerary/editTrip/components/builder-card.js